import { Flex, FlexProps, Text, UserAvatar } from 'components'
import { useUsers } from 'utils'

interface Props extends FlexProps {
  ids?: string[]
  managerId?: string
}
export default function EventMembers({ ids, managerId, ...rest }: Props) {
  const filteredIds = ids?.filter(id => id !== managerId)?.slice(0, 3)
  const { data: firstThreeUsers } = useUsers(filteredIds ?? [])

  if (!ids?.length) return null

  return (
    <Flex align="center" gap={2} {...rest}>
      <Flex>
        {firstThreeUsers.map((user, index) => (
          <UserAvatar user={user} key={user?.id ?? index} ml={index ? '-10px' : undefined} />
        ))}
        {ids.length > 3 && (
          <Flex
            align="center"
            bg="gray.400"
            borderRadius="full"
            color="white"
            height="32px"
            justify="center"
            ml="-10px"
            width="32px"
            zIndex={1}
          >
            +{ids.length - 3}
          </Flex>
        )}
      </Flex>
      <Flex flexDirection="column" justifyContent="space-between">
        <Text textStyle="bodySmall">{ids?.length}</Text>
        <Text textStyle="bodyXSmall" fontWeight="500" opacity={0.6}>
          Member{ids.length > 1 ? 's' : ''}
        </Text>
      </Flex>
    </Flex>
  )
}
